import { useState } from "react";
import { useDispatch } from "react-redux";
import { photofolioActions, addAlbum } from "../redux/reducers/reducers";
import styles from "../css/AlbumForm.module.css";

export function AlbumForm() {
    const dispatch = useDispatch();
    const [newAlbum, setNewAlbum] = useState({ text: "", images: [], createdAt: new Date().getTime()});

    const clearInput = () => {
        setNewAlbum({ ...newAlbum, text: ""});
    };

    const handleAlbumCreation = () => {
        console.log("newAlbum ",newAlbum)
        dispatch(addAlbum(newAlbum));
        clearInput();
    };

    const handleTextChange = (e) => {
        setNewAlbum({ ...newAlbum, text: e.target.value });
    };

    return (
        <div className={styles.container}>
            <div>Create an album</div>
            <div className={styles.footer}>
                <input 
                    type="text" 
                    placeholder="Album name" 
                    required 
                    onChange={handleTextChange}
                    value={newAlbum.text}
                />
                <button className={styles.btn} id={styles.clear} onClick={clearInput}>Clear</button>
                <button className={styles.btn} id={styles.create} onClick={handleAlbumCreation}>Create</button>
            </div>
        </div>
    );
}
